enum NotificationModalTypes {
    RECONNECT_DEVICE,
    RENAME_DEVICE,
    DISCONNECT_DEVICE,
    PROMOTED_REGISTRATION,
    LEVIA_GET_STARTED_NOTIFICATION,
    QSG_DEVICE_PAIRED_NOTIFICATION,
}

export default NotificationModalTypes;
